// Copyright (c) Microsoft Corporation. All rights reserved.
// Amazon Fire TV - https://developer.amazon.com/docs/fire-tv/user-agent-strings.html
// Note: hybrid WebView apps do not include the "AmazonWebAppPlatform" string
export const fireTvUserAgentRegex = /\b[Aa][Ff][Tt].*\b/;
export const isTvUserAgent = (rawUserAgent) => {
    const userAgent = rawUserAgent.toLowerCase();
    // Tizen - https://developer.samsung.com/smarttv/develop/guides/fundamentals/retrieving-platform-information.html
    if (userAgent.includes('smart-tv')) {
        return true;
    }
    // LG - https://webostv.developer.lge.com/discover/specifications/web-engine
    if (userAgent.includes('smarttv')) {
        return true;
    }
    if (fireTvUserAgentRegex.test(userAgent)) {
        return true;
    }
    return false;
};
//# sourceMappingURL=isTvUserAgent.js.map